var _excluded = ["children", "classes", "align", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
var StyledSovosButtonsGroup = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'align';
  }
})(function (_ref) {
  var align = _ref.align,
    spacing = _ref.theme.spacing;
  var getAlignment = function getAlignment() {
    if (align === 'right') return 'flex-end';
    if (align === 'center') return 'center';
    return 'flex-start';
  };
  return {
    // prevents non-icon buttons from growing in height when inline with icon
    // buttons
    alignItems: 'center',
    display: 'flex',
    justifyContent: getAlignment(),
    '& > button': {
      margin: "0 ".concat(spacing(0.5)),
      '&:first-of-type': {
        marginLeft: 0
      },
      '&:last-of-type': {
        marginRight: 0
      }
    },
    '& > .sovosIconButton': {
      margin: 0
    }
  };
});
var SovosButtonsGroup = function SovosButtonsGroup(_ref2) {
  var children = _ref2.children,
    classes = _ref2.classes,
    align = _ref2.align,
    className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledSovosButtonsGroup, _extends({
    align: align,
    className: clsx('sovosButtonGroup', className)
  }, rest), children);
};

/**
 * A group of buttons that will be next to each other with 8px of spacing
 * between them except the first and the last one that won't have margin on
 * the edges. It also exposes an align attribute to show the buttons on the
 * left, center or right section of its parent.
 *
 * @type {{ align; style: shim }}
 */
SovosButtonsGroup.propTypes = {
  /**
   * Alignment of the buttons on the button group.
   */
  align: PropTypes.oneOf(['right', 'left', 'center']),
  /**
   * The content of the button group
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  /**
   * Override or extend the styles applied to the component
   */
  classes: PropTypes.object,
  /**
   * Extend the class name applied to the root element
   */
  className: PropTypes.string,
  /**
   * Inline styles applied to the root element
   */
  style: PropTypes.object
};
SovosButtonsGroup.defaultProps = {
  align: 'left',
  classes: undefined,
  className: undefined,
  style: undefined
};
export default SovosButtonsGroup;